import { render } from "./QuanLyChamCongThoiVu.vue?vue&type=template&id=282fd820&scoped=true"
import script from "./QuanLyChamCongThoiVu.vue?vue&type=script&lang=js"
export * from "./QuanLyChamCongThoiVu.vue?vue&type=script&lang=js"

import "./QuanLyChamCongThoiVu.vue?vue&type=style&index=0&id=282fd820&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282fd820"]])

export default __exports__